import { useLang } from "../../i18n/LanguageContext";
import { Reveal } from "./Reveal";
import { SectionHead } from "./Cottages";

export const About = () => {
  const { t } = useLang();
  return (
    <section id="om-oss" className="section about" data-testid="section-om-oss">
      <div className="wrap about__grid">
        <div className="about__copy">
          <SectionHead eyebrow={t.about.eyebrow} title={t.about.title} testId="about-heading" />
          <Reveal delay={100} className="about__text" data-testid="about-text">
            <p className="about__p1">{t.about.p1}</p>
            <p>{t.about.p2}</p>
            <p>{t.about.p3}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
